import styled from 'styled-components';

export const FormContent = styled.div.attrs({})`
  min-height: 100vh;
  display: flex;
  align-items: ${(p) => (p.center ? 'center' : '')};
  justify-content: center;
  position: relative;
  padding: 0 0;
  background: ${(props) => props.theme.palette.lightgrey.main};
`;
